import { Check, AlertTriangle, AlertOctagon, WifiOff, Clock, Loader2 } from "lucide-react";

const MAP = {
  operational: { cls: "bg-[#00E676]/10 text-[#00E676] border-[#00E676]/25", Icon: Check },
  warning:     { cls: "bg-[#FFC400]/10 text-[#FFC400] border-[#FFC400]/25", Icon: AlertTriangle },
  critical:    { cls: "bg-[#FF3D00]/10 text-[#FF3D00] border-[#FF3D00]/25", Icon: AlertOctagon },
  offline:     { cls: "bg-[#5C6A82]/10 text-[#8A99AC] border-[#5C6A82]/25", Icon: WifiOff },
  planning:    { cls: "bg-primary/10 text-primary border-primary/25", Icon: Clock },
  in_progress: { cls: "bg-primary/10 text-primary border-primary/25", Icon: Loader2 },
  completed:   { cls: "bg-[#00E676]/10 text-[#00E676] border-[#00E676]/25", Icon: Check },
  awaiting_review: { cls: "bg-[#FFC400]/10 text-[#FFC400] border-[#FFC400]/25", Icon: Clock },
  resolved:    { cls: "bg-[#00E676]/10 text-[#00E676] border-[#00E676]/25", Icon: Check },
  open:        { cls: "bg-primary/10 text-primary border-primary/25", Icon: Loader2 },
};

export default function StatusBadge({ status, label, testId }) {
  const cfg = MAP[status] || MAP.offline;
  const { Icon } = cfg;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border text-[10px] font-mono uppercase tracking-wider ${cfg.cls}`}
      data-testid={testId || `status-${status}`}
    >
      <Icon className="w-3 h-3" strokeWidth={2.5} />
      {label || status.replace("_", " ")}
    </span>
  );
}
